export default __webpack_public_path__ + "9dddbbd7f8606ab8294f6cfe75ebb268.png";